import Axios from "axios";
import { store } from "../store";
import { Notify } from "../../helpers/notification";

const apiClient = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  timeout: 300000,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("flora_token");
  if (token) {
    config.headers["x-auth-token"] = token;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (err) => {
    const status = err.response?.data?.status;
    const message = err.response?.data?.message;
    if (message) Notify("danger", message);
    // `status: 420` in the body is the backend's force-logout signal: the
    // session is dead (expired/invalid token) or the tenant / property has been
    // blocked from the portal since login. Clear the persisted token as well as
    // redux state, otherwise the next request would resend the stale token.
    if (status === 420) {
      localStorage.removeItem("flora_token");
      store.dispatch({ type: "LOGOUT" });
    }
    return Promise.reject(err);
  }
);

export default apiClient;
